import React, {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import useFetch from "../hooks/useFetch";
import ProductGridWithFilter from "../components/ProductGridWithFilter";

const Products = () => {
    const {id: categoryId} = useParams();
    const [categoryTitle, setCategoryTitle] = useState("");
    const [filteredProducts, setFilteredProducts] = useState(null); // null = загрузка, [] = нет данных

    const {data: products} = useFetch(`/products`);
    const {data: categories} = useFetch(`/categories`);

    useEffect(() => {
        // Сбрасываем состояние при смене категории
        setFilteredProducts(null);

        if (products && Array.isArray(products)) {
            const filtered = products.filter(
                (product) => product.category?.id === Number(categoryId)
            );

            setFilteredProducts(filtered);

            if (filtered.length > 0) {
                setCategoryTitle(filtered[0].category?.category_name || "");
            } else {
                // Если нет товаров, попробуем получить название категории из списка категорий
                const category = categories?.find(cat => cat.id === Number(categoryId));
                setCategoryTitle(category?.category_name || "");
            }
        }
    }, [products, categoryId, categories]);

    return (
        <div className="my-16 pt-24 lg:pt-0">
            <div className="container mx-auto px-4">
                <div className="flex flex-col gap-x-[30px]">
                    <main>
                        {categoryTitle && (
                            <h1 className="text-2xl lg:text-3xl font-bold text-white mb-2">
                                {categoryTitle}
                            </h1>
                        )}

                        <ProductGridWithFilter data={filteredProducts || []}/>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Products;